var formAction = "https://landingreceiver.youandemili.com/api/v1/landing/process/json";
var gdprFormDescriptor = "https://landingreceiver.youandemili.com/api/v1/integrations/cnhgpdr/config";

var successTitle = "New Holland ti ringrazia per il tuo interessamento.";
var successMessage = "Verrai ricontattato al più presto.";
var genericError = "Siamo spiacenti ma si è verificato un errore. La invitiamo a riprovare più tardi";
var userExistError = "Indirizzo email già registrato. Provare con un indirizzo diverso.";
var errorMessage = "Campo obbligatorio.";
var errorMessageEmail = "Inserire un indirizzo email valido.";
var errorMessagePhone = "Inserire un numero di telefono che contenga il prefisso internazionale (esempio: +39xxxxxxxxx)";
var errorCityNumbers = "I numeri non sono ammessi";

var lidTasso = '-';
var lidRata = '-';

var primaRata = "prima-rata";
var tassoFisso = "tasso-fisso";


$(document).ready(function () {

    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    jQuery.validator.addMethod("notNumber", function (value, element, param) {
        var reg = /[0-9]/;
        if (reg.test(value)) {
            return false;
        } else {
            return true;
        }
    }, errorCityNumbers);

    $("#phonenumber").keypress(function (e) {
        if (String.fromCharCode(e.which).match(/[^+0-9]/)) {
            e.preventDefault();
        }
    });

    $("#city").keypress(function (e) {
        e = e || window.event;
        var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
        var charStr = String.fromCharCode(charCode);
        if (/\d/.test(charStr)) {
            e.preventDefault();
        }
    });

    $("#purchaseintention").on("change", function () {
        setPurchaseIntentionText();
    });

    // $("#promotion").on("change", function () {
    //     setPromotionText();
    //     console.log($(this).val());
    //     if ($(this).val() === primaRata) {
    //         $("#lid").val(lidRata);
    //     } else {
    //         $("#lid").val(lidTasso);
    //     }
    // });


    $(".ae-btn-submit").attr("disabled", "disabled");
    $(".ae-btn-submit").hide();

    setFormValidation();
    configLandigReceiver();
    GetFormDescriptor();
    initRecaptcha();

    calcGridTop();

    calcGridItemsTextHeight();

    calcFormTop();

    calcGridMarginTop();

    $('.ae-btn-scroll').click(function (e) {
        e.preventDefault();
        $(window).stop(true).scrollTo(this.hash, {
            duration: 5,
            offset: 0,
            easing: 'easeOutCirc'
        });

        var promo = $(this).attr("ae-data-promo");
        if (promo === undefined) {
            promo = "-";
        }

        $("#promotion").val(promo).change();

    });

    $(".ae-grid-item").hover(function () {
        var $el = $(this).find(".ae-text");
        $el.css("height", $el.attr("ae-data-h") + "px");
    }, function () {
        var $el = $(this).find(".ae-text");
        $el.css("height", "0");
    });

    var $footer = $("#copyright").html();
    $footer = $footer.replace("{year}", new Date().getFullYear());
    $("#copyright").html($footer);
});

// We listen to the resize event
window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    calcGridTop();

    calcGridItemsTextHeight();

    calcFormTop();

    calcGridMarginTop();
});

// Recalculate once images are loaded (header height affects form position)
window.addEventListener('load', () => {
    calcFormTop();
    calcGridMarginTop();
});


function calcGridTop() {
    var viwportHeigt = document.documentElement.clientHeight;
    if (viwportHeigt < 680) {
        var diff = 680 - viwportHeigt;
        //console.log(diff);
        if (diff <= 80) {
            $(".ae-main-container-left").css("padding-bottom", "120px");
        }
    } else {
        $(".ae-main-container-left").css("padding-bottom", "");
    }
}

function calcGridItemsTextHeight() {
    $(".ae-grid-item .ae-text").each(function () {
        var $el = $(this);
        $el.css("height", "");
        var h = $el.height();
        $el.attr("ae-data-h", h);
        $el.css("height", "0");
    });
}

function setPurchaseIntentionText() {
    $("#purchaseintentionText").val($("#purchaseintention option:selected").text());
}


function setPromotionText() {
    $("#promotionText").val($("#promotion option:selected").text());
}

function setFormValidation() {
    //form validate 
    $("#landing-form").validate({
        errorElement: "span",
        rules: {
            city: 'notNumber'
        },
        preferredContact: {
            required: true
        },
        messages: {
            firstname: errorMessage,
            lastname: errorMessage,
            phonenumber: errorMessage,
            postalcode: errorMessage,
            city: {
                required: errorMessage,
                notNumber: errorCityNumbers
            },
            city: errorMessage,
            purchaseintention: errorMessage,
            promotion: errorMessage,
            email: {
                required: errorMessage,
                email: errorMessageEmail
            },
            gdpr_0: errorMessage,
            gdpr_1: errorMessage,
            gdpr_2: errorMessage,
        }
    });
}

function configLandigReceiver() {
    //campaign tracking
    var gtmref = getUrlParameter("utm_source");
    var gtmcampaign = getUrlParameter("utm_campaign");
    var gtmmedium = getUrlParameter("utm_medium");
    var gtmcontent = getUrlParameter("utm_content");
    var placement = getUrlParameter("utm_placement");
    var adset = getUrlParameter("adset");
    var campaignname = getUrlParameter("campaign_name");
    var promo = getUrlParameter("promo");

    if (gtmref != undefined) {
        $("#gtmref").val(gtmref);
    }
    if (gtmcampaign != undefined) {
        $("#gtmcampaign").val(gtmcampaign);
    }

    if (gtmmedium != undefined) {
        $("#gtmmedium").val(gtmmedium);
    }

    if (gtmcontent != undefined) {
        $("#gtmcontent").val(gtmcontent);
    }

    if (placement != undefined) {
        $("#placement").val(placement);
    }

    if (adset != undefined) {
        $("#adset").val(adset);
    }

    if (campaignname != undefined) {
        $("#campaignname").val(campaignname);
    }

    if (promo != undefined) {
        if (promo === tassoFisso || promo === primaRata) {
            $("#promotion").val(promo).change();
            $(".btnCarousel").removeClass("active");
            $(".btnCarousel").removeAttr("aria-current");
            $(".btnCarousel[ae-data-promo=" + promo + "]").addClass("active");
            $(".btnCarousel[ae-data-promo=" + promo + "]").attr("aria-current", true);
            $(".carousel-item").removeClass("active");
            $(".carousel-item[ae-data-promo=" + promo + "]").addClass("active");
        }
    }

    //final form post
    $("#landing-form").submit(function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var form = $("#landing-form");

        var gdprMarketing = $("input[name=gdpr_1]:checked").val();
        var gdprMarketingThird = $("input[name=gdpr_2]:checked").val();
        console.log("gdprMarketing", gdprMarketing);
        console.log("gdprMarketingThird", gdprMarketingThird);
        if (gdprMarketing === "1" || gdprMarketingThird === "1") {
            $("#contact_email").val("1");
            $("#contact_phone").val("1");
            $("#contact_sms").val("1");
        } else {
            $("#contact_email").val("0");
            $("#contact_phone").val("0");
            $("#contact_sms").val("0");
        }

        if (form.valid()) {
            $(".ae-btn-submit").attr("disabled", "disabled");
            $("#waiting-form").removeClass("d-none");

            postData(form);
        }
        return false;
    });
}

function postData(form) {
    var formData = form.serializeArray();

    var jsonData = {
        "url": window.location.href,
        "name": $("#landingName").val(),
        "id": $("#lid").val(),
        "data": objectifyForm(formData)
    };

    //console.log(jsonData);

    //post
    $.ajax({
        async: true,
        type: "POST",
        beforeSend: function (request) {
            request.setRequestHeader("X-LID", $("#lid").val());
        },
        url: formAction,
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify(jsonData),
        success: function (resp) {
            //console.log(resp);
            var obj = JSON.parse(JSON.stringify(resp));
            if (obj.status === 1) {
                try {

                    //Tracciamento del form inviato
                    /**** GTM Navigation Event ****/
                    if (typeof dataLayer !== "undefined") {

                        dataLayer.push({
                            "event": "Pageview",
                            "pagePath": location.pathname.replace("index.html", "") + "/form-send/",
                            "pageTitle": "Forn send | " + $(document).find("title").text()
                        });
                    }

                    showSuccess()
                    document.getElementById("landing-form").reset();
                } catch (err) {
                    console.log(err)
                    showError(genericError);
                }

                $(".ae-btn-submit").removeAttr("disabled");
                $("#waiting-form").addClass("d-none");
                initRecaptcha();
            } else {

            }
        },
        error: function (err) {
            var obj = JSON.parse(JSON.stringify(err));
            //console.log("ERR");
            //console.log(obj);
            if (obj.status === 400) {
                var objResp = JSON.parse(JSON.stringify(obj.responseJSON));
                console.log(obj.responseJSON);
                if (objResp.status === 3) {
                    //console.log(objResp.validationErrors);
                    $.each(objResp.validationErrors, function (k, er) {
                        if (er["fieldName"] == "phonenumber") {
                            //em = em + errorMessagePhone + "<br />";
                            $("#phonenumber").addClass("error");
                            $('<span id="phonenumber-not-valid-error" class="error">' + errorMessagePhone + '</span>').insertAfter("#phonenumber");
                        }
                        if (er["fieldName"] == "email") {
                            showError(errorMessageEmail);
                        }
                    });
                } else if (objResp.status === 4) {
                    //email esistente
                    showError(userExistError);
                } else {
                    showError(genericError);
                }
            }
            $(".ae-btn-submit").removeAttr("disabled");
            $("#waiting-form").addClass("d-none");
            initRecaptcha();
        }
    });

}



function getUrlParameter(sParam) {

    var sPageURL = decodeURIComponent(window.location.href.substring(window.location.href.indexOf("?") + 1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

//create json from form data
function objectifyForm(formArray) {

    var returnArray = {};
    for (var i = 0; i < formArray.length; i++) {
        returnArray[formArray[i]['name']] = formArray[i]['value'];
    }
    return returnArray;
}

function showError(err) {
    bootbox.alert({
        centerVertical: true,
        message: '<h5 class="text-danger text-uppercase"></h5><div class="text-danger">' + err + '</div>'
    });
}

function showSuccess() {
    bootbox.alert({
        centerVertical: true,
        message: '<div id="form-success"><h5 class="text-uppercase">' + successTitle + '</h5><div>' + successMessage + '</div></div>',
    }

    );
}

/**** GDPR ****/

function GetFormDescriptor() {
    $.ajax({
        async: true,
        type: "GET",
        beforeSend: function (request) {
            request.setRequestHeader("X-LID", $("#lid").val());
        },
        url: gdprFormDescriptor,
        success: function (resp) {
            if (resp != null) {
                $("#gdpr").val(JSON.stringify(resp));
                GenerateFields(resp);
                $(".ae-btn-submit").removeAttr("disabled");
                $(".ae-btn-submit").show();
            }
        },
        error: function (resp) {
            //console.log(resp)

        }

    });
}

function GenerateFields(x) {
    $.each(x, function (key, val) {
        if (key === "policies") {
            $.each(val, function (index, value) {
                if (value.type === "checkbox") {
                    GenerateChecbox(value)
                }

                if (value.type === "radio") {
                    GenerateRadio(value)
                }

            });
        }


    });


}

function GenerateChecbox(policy) {
    var html =
        '<div class="form-group form-check">' +
        '<input type="checkbox" class="form-check-input gdpr-checkbox" name="gdpr_' + policy.id + '" id="gdpr_' + policy.id + '" value="1" ' + (policy.required ? "required" : "") + ' />' +
        '<label class="gdpr-policy-label form-check-label" for="gdpr_' + policy.id + '">' + policy.description + ' *</label>' +
        '</div>' +
        '</div>';

    var old = $("#gdpr-block").html();
    $("#gdpr-block").html(old + html);

}

function GenerateRadio(policy) {
    var html = ' <div class="form-group"> ' +
        '<div><div class="gdpr-scrollable">' +
        policy.title + " *<br />" + policy.description +
        '<br />' +
        '</div>' +
        '<div class="form-check form-check-inline">' +
        '<input class="form-check-input gdpr-radio " type="radio" name="gdpr_' + policy.id + '" id="gdpr_' + policy.id + '-0" value="1" required />' +
        '<label class="form-check-label" for="gdpr_' + policy.id + '-0">' + policy.accept_label + '</label>' +
        '</div>' +
        '<div class="form-check form-check-inline">' +
        '<input class="form-check-input gdpr-radio " type="radio" name="gdpr_' + policy.id + '" id="gdpr_' + policy.id + '-1" value="0" /> ' +
        '<label class="form-check-label" for="gdpr_' + policy.id + '-1">' + policy.deny_label + '</label>' +
        '</div>' +
        '</div></div>'

    var old = $("#gdpr-block").html();
    $("#gdpr-block").html(old + html);
}

function initRecaptcha() {
    if (grecaptcha?.enterprise && $("#recaptcha").length) {
        $(".ae-btn-submit").attr("disabled", "disabled");
        if (this.recaptchaIniting)
            return;
        this.recaptchaIniting = true;
        console.log("initRecaptcha");
        grecaptcha.enterprise.ready(() => {
            console.log("initRecaptcha ready");
            grecaptcha.enterprise.execute('6LcCjusqAAAAAOizm6S_Zx2v79kjLqHuNTsLO4R8', { action: "round_balers_2026_it" }).then(token => {
                //console.log("initRecaptcha new token");
                $("#recaptcha").val(token);
                $(".ae-btn-submit").removeAttr("disabled");
                this.recaptchaIniting = false;
                this.isLoading = false;
            });
        });
        clearInterval(this.recaptchaInterval);
        this.recaptchaInterval = setInterval(() => this.initRecaptcha(), 60 * 2 * 1000);
    } else {
        this.isLoading = false;
    }
}

function calcFormTop() {
    if ($(window).width() < 992) {
        $(".ae-form-container").css("margin-top", "");
    } else {
        //height of .ae-header-mobile * 0.155612 (0.155612 = distance from image top / header image height)
        var headerHeight = $(".ae-header-desktop").height() * 0.155612 - 30; //30 is the margin top of .ae-form-container
        $(".ae-form-container").css("margin-top", headerHeight + "px");
    }

}

function calcGridMarginTop() {
    var $grid = $(".ae-main-container-grid.first-grid");
    $grid.css("margin-top", "");
    if ($(window).width() < 992) {
        return;
    }
    var $form = $(".ae-form-container");
    //bottom of the form (offset already includes the form margin-top) + 50px gap
    var formBottom = $form.offset().top + $form.outerHeight() + 50;
    var diff = formBottom - $grid.offset().top;
    if (diff > 0) {
        $grid.css("margin-top", diff + "px");
    }
}